<template>
  <div>
    <div class="modal-form-block text-center tex mb-6">
      La creazione di una nuova Cordiera nasce dalla Duplicazione di una
      Cordiera già esistente
    </div>

    <div class="modal-form-block w-1/2 mx-auto py-2 text-center tex mb-6 border shadow bg-blue-100">
      Stai duplicando la cordiera
      <span class="font-bold">{{ target.string_layout_type_description }}</span>
      della <span class="font-bold">{{ target.harp.nome }}</span>
    </div>


    <div class="modal-form-block mb-6">
      <label for="harp">
        Scegli la Nuova Arpa a cui Assegnare la Cordiera:
      </label>
      <div class="relative w-full">
        <select name="harp"
                id="harp"
                v-model="harpId"
        >
          <option :value="harp.id"
                  v-for="harp in harps"
                  v-text="`${harp.cod_articolo} - ${harp.nome}`"
          >
          </option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
          </svg>
        </div>
      </div>
    </div>

    <div class="modal-form-block mb-6"
         v-show="sameHarp"
    >
      <label>Hai selezionato la stessa Arpa di Origine. Devi scegliere il nuovo tipo di cordiera.
        Non possono esistere due cordiere dello stesso tipo
      </label>
      <div class="relative w-full">
        <select name="type"
                id="type"
                v-model="typeId"
        >
          <option :value="type.id"
                  v-for="type in types"
          >
            {{ type.descrizione }}
          </option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
          </svg>
        </div>
      </div>
    </div>

    <div class="modal-form-block mb-6">
      <label for="validityDate">Data Validità</label>
      <date-picker v-model="date" :options="{firstDay: 1}"></date-picker>
    </div>

    <div class="modal-form-block mb-6">
      <button class="w-1/2 mx-auto btn is-aitems-700" @click="create">
        Crea
      </button>
    </div>
  </div>

</template>

<script>
import datePicker from '../DatePicker';
import moment from 'moment';

export default {
  components: {datePicker},

  props: {
    target: {required: true}
  },

  data() {
    return {
      harps: [],
      types: [],
      harpId: 1,
      typeId: '',
      sameHarp: false,
      date: moment().format('DD-MM-YYYY')
    }
  },

  watch: {
    harpId() {
      if (this.harpId === this.target.harp_id) {
        this.sameHarp = true;
      }
    }
  },

  mounted() {
    this.fetchHarps();
    this.fetchTypes();
  },

  methods: {
    fetchHarps() {
      axios.get('/harps')
          .then(({data}) => {
            this.harps = data;
          })
    },

    fetchTypes() {
      axios.get('/strings-layout-types')
        .then(({data}) => {
          this.types = this.stripParentType(data);
        })
    },

    stripParentHarp(harps) {
      return harps.filter((harp) => {
        return harp.id !== this.target.harp_id;
      })
    },

    stripParentType(types) {
      return types.filter((type) => {
        return type.id !== this.target.string_layout_type_id;
      })
    },

    reverseDate() {
      return this.date.split('-').reverse().join('-');
    },

    create() {
      swal.fire({
        title: 'Sei sicuro?',
        text: 'Una nuova Cordiera verrà creata',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, creami tutto!'
      }).then(({value}) => {
        if (value) {
          let payload = {
            harp_id: this.harpId,
            validity_date: this.reverseDate(),
          };

          if (this.sameHarp) {
            payload.type_id = this.typeId;
          }

          axios.post(`/strings-layouts/${this.target.id}`, payload)
              .then(({data}) => {
                location.href = `/strings-layouts/edit/${data.id}`;
              })
              .catch((error) => {
                swal.fire('Cazzo Fai!', 'Hai rotto tutto!!', 'error'); //TODO: Gestire realmente l'errore!
              });
        } else {
          console.log('Mi sono dimesso Tutto!');
        }
      });
    }
  }
}
</script>
